import { $LocalStorage, LocalStorageItem } from '../../../NonReact/utils/StorageUtils'
import { $akixi } from '../../../NonReact/common/AkixiWindow'
import { getPageName } from '../../../NonReact/common/DataIngest'

export type TourStorage = {
    [key: string]: number
}

export const TOURING_LOCAL_STORAGE_KEY: string = 'touring'

const getTourStorageFromLS = (version: string): Nullable<TourStorage> =>
    $LocalStorage.getItem<Nullable<LocalStorageItem<TourStorage>>>(TOURING_LOCAL_STORAGE_KEY, version)?.value

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
const getPageOrRoute = (): string => getPageName() ?? $akixi?.RouteID

export const getTouringStep = (version: string): number => {
    const storage: Nullable<TourStorage> = getTourStorageFromLS(version)

    if (!storage) {
        return 0
    }

    return storage[getPageOrRoute()] ?? 0
}

export const incrementTouringStep = (version: string): void => {
    const storage: Nullable<TourStorage> = getTourStorageFromLS(version)

    if (!storage) {
        $LocalStorage.setItem(
            TOURING_LOCAL_STORAGE_KEY,
            {
                [getPageOrRoute()]: 1
            },
            { version }
        )
    } else {
        $LocalStorage.setItem(
            TOURING_LOCAL_STORAGE_KEY,
            {
                ...storage,
                [getPageOrRoute()]: (storage[getPageOrRoute()] ?? 0) + 1
            },
            { version }
        )
    }
}

export const turnOffTour = (version: string): void => {
    const storage: Nullable<TourStorage> = getTourStorageFromLS(version)

    $LocalStorage.setItem(
        TOURING_LOCAL_STORAGE_KEY,
        {
            ...storage,
            [getPageOrRoute()]: -1
        },
        { version }
    )
}

export const restartTour = (): void => {
    $LocalStorage.removeItem(TOURING_LOCAL_STORAGE_KEY)
    window.location.reload()
}
